import Activity from '@/models/Activity';

export default class Meeting extends Activity {
  constructor({
    reference, departurePath, returnPath, originalActivity, meetingRoom, participant,
  }) {
    super({ reference });

    this.reference.skills.moving.setPath(departurePath);
    this.onReturnPath = false;
    this.returnPath = returnPath;
    this.participant = participant;

    this.originalActivity = originalActivity;
    this.meetingRoom = meetingRoom;

    this.done = false;
  }

  execute() {
    if (this.onReturnPath) {
      this.finish();
      return;
    }

    if (this.done) {
      if (this.meetingRoom) {
        this.meetingRoom.leave(this.reference);
      }
      this.reference.skills.moving.setPath(this.returnPath);
      this.onReturnPath = true;
      return;
    }

    if (this.participant.hasArrived) {
      this.endMeeting();
      this.participant.activity.endMeeting();
    }
  }

  endMeeting() {
    this.done = true;
  }

  finish() {
    this.reference.setOnSeat();
    this.reference.setActivity(this.originalActivity);
  }
}
